/**
 * Camera image URIs are served by the CDN, which applies perspective transform by
 * default. `pt=0` requests the raw, untransformed capture.
 */
export const withoutPerspectiveTransform = (imageUri: string): string => {
  const separator = imageUri.includes('?') ? '&' : '?';

  return `${imageUri}${separator}pt=0`;
};
